import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_7: FaireProductEntity = {
  token: "driftless-studios-7",
  type: "product",
  name: "10x10 Silence is golden unless you have children wall art",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/343980bf273f5e6d38300fd0cc757fc62d65248e2a251f423b792cf572681d26.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
